import React from 'react';
import PropTypes from 'prop-types';

import DropDown from '../drop-down';

export default class Select extends React.Component {

	static propTypes = {
		value: PropTypes.any,
		onChange: PropTypes.func,
		items: PropTypes.array,
		showValue: PropTypes.any,
		empty: PropTypes.any,
		footer: PropTypes.any,
		multiple: PropTypes.bool,
		isRequired: PropTypes.bool,
		disabled: PropTypes.bool,
		isLoading: PropTypes.bool,
		comparator: PropTypes.func,
		onSearch: PropTypes.func,
		noSearch: PropTypes.bool,
		onBlur: PropTypes.func,
		className: PropTypes.string,
		listClassName: PropTypes.string,
		position: PropTypes.string,
		listMaxHeight: PropTypes.number,
		autoActivate: PropTypes.bool,
	};

	static defaultProps = {
		empty: '-',
		multiple: false,
		isRequired: false,
		autoActivate: false,
		isLoading: false,
		__data: {},
		position: null,
	};

	constructor(props) {
		super(props);
		this.state = { filter: '' };
	}

	onMount = el => {
		this.el = el;
		if (this.props.getRef) this.props.getRef(el);
	};

	isObjectItem = item => item &&
		typeof item === 'object' &&
		item.hasOwnProperty('label') &&
		item.hasOwnProperty('value') &&
		!item.hasOwnProperty('MODEL');

	itemValue = item => this.isObjectItem(item) ? item.value : item;
	itemLabel = item => this.isObjectItem(item) ? item.label : item;

	comparator = (a, b) => {
		return this.props.comparator ?
			this.props.comparator(this.itemValue(a), this.itemValue(b))
			:
			this.itemValue(a) === this.itemValue(b);
	};

	onSearch = str => {
		const trimmed = str.trim();
		if (this.props.onSearch) {
			this.props.onSearch(trimmed);
		}
		else {
			this.setState({ filter: trimmed });
		}
	};

	onSelectItem = async (selectedItem) => {
		const itemValue = this.itemValue(selectedItem);
		// console.log('onSelectItem', itemValue);

		let _value = this.props.value;
		if (this.props.computed) _value = this.props.computed(_value);

		if (this.props.multiple) {
			const items = _value ? [..._value] : [];
			const index = items.findIndex(item => this.comparator(item, selectedItem));
			if (index === -1) {
				items.push(itemValue);
			}
			else {
				items.splice(index, 1);
			}
			if (this.props.onChange) {
				await this.props.onChange(items, index === -1 ? selectedItem : undefined);
			}
		}
		else {
			if (this.props.onChange) {
				await this.props.onChange(itemValue);
			}
		}
	};

	render() {
		let {
			value,
			computed,
			items,
			selected,
			empty,
			comparator,
			className,
			footer,
			...rest
		} = this.props;

		let showValue = null;

		if (computed) value = computed(value);

		if (this.props.showValue) {
			showValue = this.props.showValue;
		}
		else if (this.props.multiple) {
			if (value instanceof Array) {
				showValue = 'selected: ' + value.length;
			}
			else if (value !== null && value !== undefined) {
				console.error('value is not an array!', value)
			}
		}
		else {
			showValue = items.find(item => this.comparator(item, value));
		}

		if (this.isObjectItem(showValue)) {
			showValue = showValue.label;
		}

		const _selected = this.props.multiple ? (value ? [...value] : []) : (value || null);

		let _items = [...items];
		if (!this.props.onSearch && this.state.filter) {
			_items = items.filter(item => {
				const r = new RegExp(this.state.filter, 'ig');
				return r.test(this.itemLabel(item));
			});
		}
		const objectFormat = items && items.length && this.isObjectItem(items[0]);
		if (!this.props.isRequired) _items.splice(0, 0, objectFormat ? { label: empty, value: null } : empty);

		const _className = [
			className || '',
			this.props.__data.inTable ? ' drop-down-sm in-table-input' : ''
		].join(' ').trim();

		return <>
			<DropDown
				items={_items}
				selected={_selected}
				className={_className}
				showValue={showValue || empty}
				getRef={this.onMount}
				onSelectItem={this.onSelectItem}
				onInputChange={this.onSearch}
				comparator={comparator}
				actions={footer}
				{...rest}
/*
				listClassName={this.props.listClassName}
				listMaxHeight={this.props.listMaxHeight}
				disabled={this.props.disabled}
				isLoading={this.props.isLoading}
				onBlur={this.props.onBlur}
				noSearch={this.props.noSearch}
				listRef={this.props.listRef}
				beforeInput={this.props.beforeInput}
				position={this.props.position}
				alwaysActive={this.props.alwaysActive}
				autoActivate={this.props.autoActivate}
*/
			/>
		</>;
	}

}
